"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fetchExtensions_1 = require("spry-react/utils/fetchExtensions");
var ZipCodesApiClient = /** @class */ (function () {
    function ZipCodesApiClient(addressSuggestionUrl) {
        this.addressSuggestionUrl = addressSuggestionUrl;
    }
    ZipCodesApiClient.prototype.getAddressSuggestion = function (zipCode, onNetworkError) {
        /* note: this end-point was written to support the existing address field, which expects the results
           in CamelCase, hence the mapping to a camelCase version here */
        return fetchExtensions_1.getJson(fetchExtensions_1.urlWithData(this.addressSuggestionUrl, { zipCode: zipCode }))
            .then(function (response) {
            if (response.ok)
                return response.json();
            else
                return undefined;
        })
            .then(function (response) { return response; })
            .then(function (results) {
            return {
                cities: results.Cities,
                counties: results.Counties,
                country: results.Country,
                defaultCity: results.DefaultCity,
                defaultCounty: results.DefaultCounty,
                defaultState: results.DefaultState,
                states: results.States.map(function (s) { return { state: s.State, stateName: s.StateName }; })
            };
        })
            .catch(function () { return undefined; });
    };
    return ZipCodesApiClient;
}());
exports.ZipCodesApiClient = ZipCodesApiClient;
